import TrackPlayer, { State as RNTPState } from 'react-native-track-player';
import { getPositionTime } from '@annunciate/ui/dist/utils/progress';
export const onPlayCurrentAudio = async (initialPosition) => {
    const playbackState = (await TrackPlayer.getPlaybackState()).state;
    const isPlaying = playbackState === RNTPState.Playing;
    if (playbackState === RNTPState.None || playbackState === RNTPState.Buffering) {
        console.error("none playback state");
        throw new Error("Need to reload audio.");
    }
    if (initialPosition) {
        await TrackPlayer.seekTo(getPositionTime(initialPosition));
    }
    if (!isPlaying) {
        await TrackPlayer.play();
    }
};
//# sourceMappingURL=onPlayCurrentAudio.js.map